import React, { useState, useEffect } from 'react';

const Carousel = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const count = React.Children.count(children);

    const nextSlide = React.useCallback(() => {
        setActiveIndex((prev) => (prev + 1) % count);
    }, [count]);

    const prevSlide = React.useCallback(() => {
        setActiveIndex((prev) => (prev - 1 + count) % count);
    }, [count]);

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight') {
                nextSlide();
            } else if (e.key === 'ArrowLeft') {
                prevSlide();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [nextSlide, prevSlide]);

    return (
        <div className="carousel-container">
            <div className="carousel-track" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
                {React.Children.map(children, (child, index) => (
                    <div className="carousel-slide" key={index}>
                        {child}
                    </div>
                ))}
            </div>

            <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide} aria-label="Previous Slide">
                &#10094;
            </button>
            <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide} aria-label="Next Slide">
                &#10095;
            </button>

            <div className="carousel-dots">
                {Array.from({ length: count }).map((_, index) => (
                    <button
                        key={index}
                        className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
                        onClick={() => setActiveIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Carousel;
